module.exports = __webpack_public_path__ + "static/media/grocery_set.04b37fbb.svg";